<div class="w-full h-full flex flex-col">
  <div class="flex justify-end p-4 bg-transparent">
    <button class="p-2 rounded hover:bg-gray-100" (click)="onClose()" aria-label="Close">✕</button>
  </div>
<!--  @if (content?.video) {-->
<!--    <app-video-viewer class="flex-1 min-h-0" [content]="content"></app-video-viewer>-->
<!--  } @else if (content?.audio) {-->
<!--    <app-audio-viewer class="flex-1 min-h-0" [content]="content"></app-audio-viewer>-->
<!--  } @else if (content?.url) {-->
  @if(!!url){
    <app-web-viewer class="flex-1 min-h-0" [url]="url"></app-web-viewer>
  }

<!--  }-->
</div>

